module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_9_m.6b6dc1bc16ccd21bdd72315f9ec77d31.png";